import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class MessageBoxText extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-msg-box__text',
            className,
        ];
    }

}

MessageBoxText.propTypes = propTypes;

MessageBoxText.defaultProps = defaultProps;

export default MessageBoxText;
